import { payrollRequest, payrollSuccess, payrollFailure } from "../payroll";

import { $api } from "../../../services/request.config";
import {mode} from "../../../../app/mode";
import countly from "../../../../analytics/countly";
import { EVENT_NAMES } from "../../../../analytics/events";

export const asyncPayrollAction = (data) => async(dispatch) => {
    try {
        dispatch(payrollRequest());
        console.log(mode)
        const response = await $api(`/v3/pr/all/${data.year <= 1992 ? 1992 :data.year }/${data.months}`);
        if (response.data) {
            countly.event(EVENT_NAMES.PAYROLL_VIEWED, { pid: localStorage.getItem("pid") });
         return   dispatch(payrollSuccess(response));
        } else {
            return   dispatch(payrollSuccess(null));
        }
    } catch (error) {
        dispatch(payrollFailure(error));
    }
};
